import { useMemo } from 'react';
import type { DemoLogin } from '../../core/types/backend';
type Props = {
  /** Uit accountApi.demoLogins — alleen aanwezig zonder backend. */
  logins: () => DemoLogin[];
  selectedEmail: string;
  onPick: (email: string, password: string) => void;
};

/**
 * DEMO — kies een voorbeeldklant om in te loggen. Dezelfde klanten als in
 * het beheer (/be/klanten). Met een backend is `accountApi.demoLogins` leeg
 * en wordt dit niet getoond.
 */
export function DemoLoginPicker({
  logins,
  selectedEmail,
  onPick
}: Props) {
  const list = useMemo(() => logins(), [logins]);
  const password = list[0]?.password;
  if (list.length === 0) return null;
  return <section aria-labelledby="demo-logins" className="mt-6 bg-blush/50 p-4 text-[13px] text-ink" data-id="element-6221" data-mp="9vga47i7uppt">
      <h2 id="demo-logins" className="text-[13px] font-normal" data-id="element-6222" data-mp="5y1xe5vbtzt2">
        Demo: kies een klant om in te vullen.{password && <> Wachtwoord <span className="tabular-nums" data-id="element-6223" data-mp="1hbe5isy4d4l1">{password}</span>.</>} Dit zijn dezelfde klanten als in het beheer.
      </h2>
      <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-6224" data-mp="3qm7mspuo90nk">
        {list.map(d => <li key={d.email} data-id="element-6225" data-mp="3vjzrylkbuj9p">
            <button type="button" aria-pressed={selectedEmail === d.email} onClick={() => onPick(d.email, d.password)} className={`h-full w-full bg-shell px-3 py-2.5 text-left ring-1 transition-shadow duration-150 ease-soft ${selectedEmail === d.email ? 'ring-ink' : 'ring-line hover:ring-ink/40'}`} data-id="element-6226" data-mp="3vj6hpam5tbmt">
              <span className="block text-[14px] text-ink" data-id="element-6227" data-mp="3bxbldbn4elvx">{d.label}</span>
              <span className="block text-[12px] leading-snug text-muted" data-id="element-6228" data-mp="3gvd1bnp92536">{d.description}</span>
            </button>
          </li>)}
      </ul>
    </section>;
}